import { Component, OnInit } from '@angular/core';
import { AbstractControl,FormBuilder, FormControl, Validators,ValidationErrors  } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { TransfereService } from 'src/app/transfere.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '@angular/common';
import { } from 'googlemaps';
import { IMyDpOptions } from 'mydatepicker';
import { count } from 'console';
declare var $: any;
@Component({
  selector: 'app-add-customers',
  templateUrl: './add-customers.component.html',
  styleUrls: ['./add-customers.component.css']
})
export class AddCustomersComponent implements OnInit {
  customerRegisterForm: any;
  error = { 'description': [] };
  userDetails = { 'usertype': '', 'sub': '' };
  tempUserDetails!:any;
  autocompleteItems: any[] = [];
  addressErr = false;
  city = '';
  state = '';
  country = '';
  selectedCountry='';
  postal_code = '';
  currentLng;
  currentLat;
  isCityhidden: boolean = false;
  isStatehidden: boolean = false;
  maxLength = 10;
  minLength = 10;
  maxLengthNumber: any = 10;
  countryList = [];
  countryCode = '';
  userCountryName='';
  userCountryCode ='';
  userCountryDetails: any[] = [];
  language = '';
  tractors = [];
  serialNoErr = false;
  tractorModelList = [];
  isInvalid = false;
  selectedState='';
  selectedCity='';

  public startDateOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    showInputField: true,
    editableDateField: false,
    height: '28px',
    showClearDateBtn: false,
    disableSince: { year: 0, month: 0, day: 0 }
  };
  constructor(private fb: FormBuilder, public apiService: ApiService, public transfereservice: TransfereService, private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private location: Location) {
    if (localStorage.getItem('userDetails') != null) {
      this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
       this.tempUserDetails= JSON.parse(localStorage.getItem('userDetails'));
      console.log('userDetails')
      console.log(this.tempUserDetails);
      if (this.tempUserDetails.countryDetails) {
        this.userCountryDetails = JSON.parse(this.tempUserDetails.countryDetails);
      } 
      console.log( this.userCountryDetails);
      // this.userCountryName = this.userCountryDetails[0].countryName;
      // this.userCountryCode = this.userCountryDetails[0].countryCode;

      console.log('usercountry:- ' + this.userDetails['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country']);
      
    }
    // this.customerRegisterForm = this.fb.group({
    //   Name: new FormControl('', [Validators.required, this.namealphabetsValidator]),
    //   Address: new FormControl('', [Validators.required]),
    //   city: new FormControl('', [Validators.required, this.namealphabetsValidatornew]),
    //   state: new FormControl('', [Validators.required, this.namealphabetsValidatornew]),
    //   country: new FormControl('', Validators.required),
    //   selectedCountry: new FormControl('',Validators.required),
    //   mobileNo: new FormControl('', Validators.required)
    // });
    this.customerRegisterForm = this.fb.group({
      Name: new FormControl('', [Validators.required, this.namealphabetsValidatornew]),
      Address: new FormControl('', ),
      city: new FormControl('', [this.namealphabetsValidatornew]),
      state: new FormControl('', [this.namealphabetsValidatornew]),
      country: new FormControl('', Validators.required),
      selectedCountry: new FormControl('',Validators.required),
      mobileNo: new FormControl('', Validators.required)
    });
    this.customerRegisterForm.get('mobileNo').disable();
  }

  public namealphabetsValidator(control: FormControl) {
    let isValid = false;
    var regex = /[^a-zA-Z ]/;
    if (control.value && control.value.trim().length >= 1 && control.value.trim().length <= 30 && !regex.test(control.value)) {
      isValid = true;
      return isValid ? null : { 'alphabets': true }
    } else {
      return isValid ? null : { 'alphabets': false }
    }
  }
  public namealphabetsValidatornew(control: AbstractControl): ValidationErrors | null {

  if (control.value == null || control.value == '') {
    return null;
  }

  const value = control.value.toString().trim();
  const regex = /^[A-Za-z ]+$/;

  if (!regex.test(value)) {
    return { alphabets: true };
  }

  return null;
}

  public alphabetsValidator(control: FormControl) {
    let isValid = false;
    // var regex = /[^a-zA-Z ]/;
    if (control.value && control.value.trim().length >= 2 && control.value.trim().length <= 50) {
      isValid = true;
      return isValid ? null : { 'alphabets': true }
    } else {
      return isValid ? null : { 'alphabets': false }
    }
  }

  ngOnInit() {
    // this.getCountryList();
    this.callList();
    this.disableSince();
  }

  disableSince() {
    let d: Date = new Date();
    d.setDate(d.getDate() + 1);
    let copy: IMyDpOptions = this.getCopyOfOptions();
    copy.disableSince = {
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate()
    };
    this.startDateOptions = copy;
  }
  getCopyOfOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.startDateOptions));
  }

  callList() {
    if (this.userDetails.usertype == 'Admin')
    {
      this.getCountryList();
    } else //if (this.userDetails.usertype == 'CountryHead')
    {
      //this.countryList=JSON.parse(this.userDetails.countryDetails);
      //this.country = this.userDetails['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country'];
      this.selectedCountry = this.userDetails['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country'];

      console.log('other user country:- ' + this.selectedCountry);

      this.customerRegisterForm.patchValue({
              country: this.selectedCountry
            });

      this.customerRegisterForm.patchValue({
              selectedCountry: this.selectedCountry
            });
      this.country= this.selectedCountry;

            this.customerRegisterForm.get('mobileNo').enable();

      this.getTractorDetailsForOtherUser(this.selectedCountry);
        
  }
}

  getCountryList() {
    this.spinner.show();
    this.apiService.getCountryList({}).subscribe((response: any) => {
      
      this.countryList = response.content.payLoad;
      this.spinner.hide();
      if (this.userDetails['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country']) {
        this.countryList.forEach(element => {
          if (element.countryName == this.userDetails['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country']) {
            if (this.userDetails.usertype != 'Admin') {
              this.countryCode = element.countryCode;
            }
            this.customerRegisterForm.get('mobileNo').enable();
            this.minLength = element.mobileNumberLength['min'];
            this.maxLength = element.mobileNumberLength['max'];
          }
        });
      }
      
    }, error => {
      this.spinner.hide();
    });
  }
  

  getAddress() {
    this.error = { 'description': [] };
    this.tractorModelList = [];
    this.cancelTractors();
    this.autocompleteItems = [];
    this.country = '';
    this.addressErr = false;
    this.customerRegisterForm.get('city').reset('');
    this.customerRegisterForm.get('state').reset('');

    //this.country = this.userCountryName;
    //alert('this.country:- ' + this.country);
    var regex = /[^a-zA-Z0-9(),.-/\ ]/;
    this.spinner.show()
    // if (this.customerRegisterForm.get('Address').value.length >= 10 && !regex.test(this.customerRegisterForm.get('Address').value)) {
    if (this.customerRegisterForm.get('Address').value.trim() && this.customerRegisterForm.get('Address').value.length >= 10 ) {
      this.apiService.getPlacePredictions(this.customerRegisterForm.get('Address').value, this.countryCode.toLowerCase()).then(result => {
        this.spinner.hide();
        //console.log(result);
        console.log('this.addressErr:-' + this.addressErr);
        //console.log(typeof result);
        this.autocompleteItems = <Array<any>>result;
        //console.log(this.autocompleteItems);
        $('.dropdown').css('display', 'inline');
      }, error => {
        console.error(error);
        this.spinner.hide();
      });
    } else {
      this.addressErr = true;
      this.spinner.hide();
    }
  }

  chooseItem(item: any) {
    //console.log(item);
    // $('.dropdown').css('display','none');
    this.tractorModelList = [];
    this.cancelTractors();
    this.error = { 'description': [] };
    this.customerRegisterForm.patchValue({
      Address: item.description
    })
    this.autocompleteItems = [];
    var geocoder = new google.maps.Geocoder();
    var self = this;

      let city = '';
      let state = '';
    this.apiService.getgeoAddress(item.place_id).then(result => {
      this.spinner.hide();
      console.log('geoaddress result');
      console.log(result);
      var results = <Array<any>>result;
      results[0].address_components.forEach(element => {
        console.log(element.types[0]);
        if (element.types.includes('locality')) {
          if (!self.city || self.city === '') {
            self.city = element.long_name;

            self.customerRegisterForm.patchValue({
              city: element.long_name
            });
          }
        }
        if (element.types[0] == 'administrative_area_level_2') {
          console.log('cityname:- ' + element.long_name);
          self.city = element.long_name;
          self.customerRegisterForm.patchValue({
            city: element.long_name
          })
          //get City
        }
        if (element.types[0] == 'administrative_area_level_1') {
          console.log('state name :- ' + element.long_name);
          self.state = element.long_name;
          self.customerRegisterForm.patchValue({
            state: element.long_name
          })
          //get State
        }
        if (element.types[0] == 'country') {
          console.log('COUNTRY NAME' + element.long_name);
          //get Country
          if (element.long_name == 'Myanmar (Burma)') {
            element.long_name = 'Myanmar';
          }
          // else if(element.long_name == null || element.long_name == undefined || element.long_name == ''){
          //   element.long_name =this.userCountryName;
          // }
          console.log('long_name ' + element.long_name);
          const index = this.countryList.map(e => e.countryName).indexOf(element.long_name);
          if (index > -1) {
            self.country = element.long_name;
            self.customerRegisterForm.patchValue({
              country: element.long_name
            })
            this.getTractorModels(element.long_name);
            self.language = this.countryList[index].languages[0].languageName
            this.customerRegisterForm.get('mobileNo').enable();
            this.customerRegisterForm.get('mobileNo').reset('');
            this.minLength = this.countryList[index].mobileNumberLength['min'];
            this.maxLength = this.countryList[index].mobileNumberLength['max'];

          } else {
            this.error = { 'description': [] };
            this.error.description.push('Cannot create customer for selected country.');
            this.customerRegisterForm.get('mobileNo').disable();
            this.customerRegisterForm.get('mobileNo').reset('');
            this.minLength = 10;
            this.maxLength = 10;
            self.country = '';
          }
        }
        if (element.types[0] == 'postal_code') {
          //console.log(element.long_name);
          self.postal_code = element.long_name;
          //get Postal
        }
      });
      //console.log(self.customerRegisterForm.get('city').value);
      //console.log(self.customerRegisterForm.get('state').value);

      // if (self.customerRegisterForm.get('city').value == undefined || self.customerRegisterForm.get('city').value == "") {
      //   self.isCityhidden = false;
      // }
      // if (self.customerRegisterForm.get('state').value == undefined || self.customerRegisterForm.get('state').value == "") {
      //   self.isStatehidden = false;
      // }

      self.isCityhidden = false;
      self.isStatehidden = false;
      

      //console.log(self.customerRegisterForm);
      //console.log(self.customerRegisterForm['status']);
      this.customerRegisterForm['status'] = self.customerRegisterForm['status'];
      $('#updateName').trigger('click');
      var lat = results[0].geometry.location.lat();
      var lng = results[0].geometry.location.lng();
      //console.log(lat, lng);
      self.currentLat = lat;
      self.currentLng = lng;
    }, error => {
      console.log('error');
      console.log(error);
      console.error(error);
      this.spinner.hide();
    });
  }

//  chooseItem1(item: any): void {
//   if (!item || !item.place_id) return;

//   this.tractorModelList = [];
//   this.cancelTractors();
//   this.error = { description: [] };

//   this.city = '';
//   this.state = '';
//   this.country = '';

//   this.customerRegisterForm.patchValue({
//     Address: item.description || ''
//   });

//   this.autocompleteItems = [];
//   this.spinner.show();

//   this.apiService.getgeoAddress(item.place_id)
//     .then((result: any) => {
//       this.spinner.hide();

//       if (!result || result.length === 0) return;

//       var address = result[0];
//       var components = address.address_components || [];

//       for (var i = 0; i < components.length; i++) {

//         var comp = components[i];
//         var types = comp.types || [];
//         var value = comp.long_name || '';

//         // CITY
//         if (types.indexOf('locality') > -1 && this.city === '') {
//           this.city = value;
//           this.customerRegisterForm.patchValue({ city: value });
//         }

//         if (types.indexOf('administrative_area_level_2') > -1) {
//           this.city = value;
//           this.customerRegisterForm.patchValue({ city: value });
//         }

//         // STATE
//         if (types.indexOf('administrative_area_level_1') > -1) {
//           this.state = value;
//           this.customerRegisterForm.patchValue({ state: value });
//         }

//         // COUNTRY
//         if (types.indexOf('country') > -1) {

//           // if (!value) {
//           //   value = this.userCountryName;
//           // }

//           if (value === 'Myanmar (Burma)') {
//             value = 'Myanmar';
//           }

//           var found = null;
//           for (var j = 0; j < this.countryList.length; j++) {
//             if (this.countryList[j].countryName === value) {
//               found = this.countryList[j];
//               break;
//             }
//           }

//           if (found) {
//             this.country = value;

//             this.customerRegisterForm.patchValue({
//               country: value
//             });

//             this.getTractorModels(value);

//             if (found.languages && found.languages.length > 0) {
//               this.language = found.languages[0].languageName;
//             }

//             var mobileCtrl = this.customerRegisterForm.get('mobileNo');
//             if (mobileCtrl) {
//               mobileCtrl.enable();
//               mobileCtrl.reset('');
//             }

//             this.minLength = found.mobileNumberLength ? found.mobileNumberLength.min : 10;
//             this.maxLength = found.mobileNumberLength ? found.mobileNumberLength.max : 10;

//           } else {
//             this.error = { description: ['Cannot create customer for selected country.'] };

//             var mobileCtrl2 = this.customerRegisterForm.get('mobileNo');
//             if (mobileCtrl2) {
//               mobileCtrl2.disable();
//               mobileCtrl2.reset('');
//             }

//             this.minLength = 10;
//             this.maxLength = 10;

//             this.country = '';
//           }
//         }

//         // POSTAL CODE
//         if (types.indexOf('postal_code') > -1) {
//           this.postal_code = value;
//         }
//       }

//       this.isCityhidden = false;
//       this.isStatehidden = false;

//       // LAT LNG
//       if (address.geometry && address.geometry.location) {
//         this.currentLat = address.geometry.location.lat();
//         this.currentLng = address.geometry.location.lng();
//       }

//     })
//     .catch((error: any) => {
//       this.spinner.hide();
//       console.error('GeoAddress error:', error);
//     });
// }

//NO USE
   getCountryDetails(item: any) {
    console.log('item' + item);
   
    this.tractorModelList = [];
    this.cancelTractors();
    this.error = { 'description': [] };
    this.customerRegisterForm.patchValue({
      Address: item
    })
    this.autocompleteItems = [];
   
    var self = this;

      let city = '';
      let state = '';   
      //console.log(result);
             
          self.city = this.city;
          self.customerRegisterForm.patchValue({
            city: this.city
          })
          //get City
        
          self.state = this.state;
          self.customerRegisterForm.patchValue({
            state:  this.state
          })
         
                  
          const index = this.countryList.map(e => e.countryName).indexOf(this.userCountryName);
          if (index > -1) {
            self.country = this.userCountryName;
            self.customerRegisterForm.patchValue({
              country: this.userCountryName
            })
            this.getTractorModels(this.userCountryName);
            self.language = this.countryList[index].languages[0].languageName            
            this.minLength = this.countryList[index].mobileNumberLength['min'];
            this.maxLength = this.countryList[index].mobileNumberLength['max'];

          } 
        
        
    
      
      

      
    
  }

  addCustomers() {
    //console.log(this.updateForm);
    this.isInvalid = false;
    if (this.tractors.length > 0) {
      this.tractors.forEach(element => {
        if (element.purchasedOn && element.purchasedOn.date) {
          element.purchasedOn = element.purchasedOn.date.year + '-' + element.purchasedOn.date.month + '-' + element.purchasedOn.date.day;
          return;
        } else {
          this.isInvalid = true;
        }
      });
    }
    let data = {
      "mobileNo": this.customerRegisterForm.value.mobileNo,
      "name": this.customerRegisterForm.value.Name,
      "country": this.customerRegisterForm.value.country,
      "location": {
        "type": "Point",
        "coordinates": [this.currentLng, this.currentLat]
      },
      "tractors": this.tractors,
      "addressLine": this.customerRegisterForm.value.Address,
      "city": this.customerRegisterForm.value.city,
      "state": this.customerRegisterForm.value.state,
      "language": this.language
    }
    console.log(data);
    console.log(this.tractors);
    this.apiService.insertCustomer(data).subscribe(response => {
      //console.log(response);
      //Added Successfully
      this.router.navigate(['/customers'], { queryParams: { id: 2 } });
    }, error => {
      //Error while updating
      //console.log(error.error);
      //console.log(error.error.errors[0]);
      //console.log(error.error.errors[0].description);
      this.error = { 'description': [] };
      this.error.description.push(error.error.errors[0].description);
      //console.log(this.error);
    })
  }

  cancel() {
    this.router.navigate(['/customers']);
  }

  trashTractor(i) {
    //console.log(i, "iiii...")
    if (this.tractors.length > 0) {
      this.tractors.splice(i, 1);
    }
  }

  addTractor() {
    this.tractors.push({
      tractorName: "",
      serialNo: "",
      purchasedOn: "",
      active: true,
      index: 0      
      
    });
    
    $("#collapseadd").addClass('show');
  }

  checkSerialNo(selectedNo) {
    var regex = /[^a-zA-Z0-9- ]/;
    this.serialNoErr = false;
    //console.log(regex.test(selectedNo.serialNo));
    //console.log(!regex.test(selectedNo.serialNo));

    if (selectedNo.serialNo.trim().length >= 5 && selectedNo.serialNo.trim().length < 18 && !regex.test(selectedNo.serialNo.trim())) {
      this.tractors.forEach(element => {
        if (element.serialNo == selectedNo.serialNo) {
          element.serialNoErr = false;
        }
      });
    } else {
      this.tractors.forEach(element => {
        if (element.serialNo == selectedNo.serialNo) {
          element.serialNoErr = true;
          this.serialNoErr = true;
        }
      });
    }
  }

  onCountryChange(event: any): void {
    const countryName = event.target.value;
    //alert('Country name:- ' + countryName);
    this.country= countryName
    this.getTractorModels(countryName);
    var self = this;

    //self.city
    self.customerRegisterForm.patchValue({
            city: this.selectedCity
          })

    //self.state = element.long_name;
          self.customerRegisterForm.patchValue({
            state: this.selectedState
          })
    
       const index = this.countryList.map(e => e.countryName).indexOf(countryName);
          if (index > -1) {
            self.country = countryName;
            self.customerRegisterForm.patchValue({
              country: countryName
            })            
            self.language = this.countryList[index].languages[0].languageName
            
            this.minLength = this.countryList[index].mobileNumberLength['min'];
            this.maxLength = this.countryList[index].mobileNumberLength['max'];

          } else {
            this.error = { 'description': [] };
            //this.error.description.push('Cannot create customer for selected country.');           
            
            this.minLength = 10;
            this.maxLength = 10;
            self.country = '';
          }   

          this.customerRegisterForm.patchValue({
              selectedCountry: countryName
            });

          self.postal_code = "";
          self.currentLat = 0;
          self.currentLng = 0;
          this.currentLng=0;
          this.currentLat=0;
  }

  getTractorDetailsForOtherUser(countryname: any): void {
    const countryName = countryname;
    //alert('Country name:- ' + countryName);
    this.country= countryName
    this.getTractorModels(countryName);
    var self = this;

    //self.city
    self.customerRegisterForm.patchValue({
            city: this.selectedCity
          })

    //self.state = element.long_name;
          self.customerRegisterForm.patchValue({
            state: this.selectedState
          })
    
       const index = this.countryList.map(e => e.countryName).indexOf(countryName);
          if (index > -1) {
            self.country = countryName;
            self.customerRegisterForm.patchValue({
              country: countryName
            })            
            self.language = this.countryList[index].languages[0].languageName
            
            this.minLength = this.countryList[index].mobileNumberLength['min'];
            this.maxLength = this.countryList[index].mobileNumberLength['max'];

          } else {
            this.error = { 'description': [] };
            //this.error.description.push('Cannot create customer for selected country.');           
            
            this.minLength = 10;
            this.maxLength = 10;
            self.country = '';
          }   

          self.postal_code = "";
          self.currentLat = 0;
          self.currentLng = 0;
          this.currentLng=0;
          this.currentLat=0;
  }

  getTractorModels(countryName) {
    const query = {
      "itemsPerPage": -1,
      "filters": [{
        "member": "country", "value": countryName, "operation": "EqualTo"
      }, {
        "member": "isactive", "value": true
      }]
    }
    this.apiService.getTractorModels(query).subscribe(response => {
      //console.log(response);
      this.tractorModelList = []
      this.tractorModelList = response['content'].payLoad;
      this.spinner.hide();
      //console.log(this.tractorModelList);
    }, error => {
      this.spinner.hide();
      //console.log(error);
    })
  }

  modelChanged(data, item) {
    console.log(data);
    console.log(item);
    var id;
    this.tractorModelList.forEach(element => {
      if (element.tractorName == data) {
        id = element.id;
        return;
      }
    });

    this.tractors.forEach((element, index) => {
      if (element.tractorName == data) {
        element.id = id;
        element.index = index;
        element.active = true;
      }
    });
    console.log(this.tractors);

  }

  changeStatus(selectedData) {
    console.log(this.tractors);

    this.tractors.forEach((element, index) => {
      if (index == selectedData.index) {
        element.active = !element.active;
      }
    });
  }

  validateTractorsData() {
    console.log(this.tractors);
    this.isInvalid = false;
    if (this.tractors.length > 0) {
      this.tractors.forEach(element => {
        if (!element.serialNo || !element.tractorName || !element.purchasedOn) {
          //console.log('1')
          this.isInvalid = true;
          return;
        } else if (element.serialNoErr) {
          this.serialNoErr = true;
          return;
        }
      });
      console.log(this.tractors);
      if (!this.isInvalid) {
        this.addCustomers();
      } else {
        return;
      }
    } else {
      this.addCustomers();
    }

  }

  closeAlert() {
    this.error.description = [];
  }

  cancelTractors() {
    this.tractors = [];
    $("#collapseadd").removeClass('show');
    $("#collapseview").addClass('collapse show');
    this.isInvalid = false;
    this.serialNoErr = false;
  }
}
